export const contactsEmail = "info@gofarsoft.org";
export const contactsPhone = "+375296514879";
export const displayedContactsPhone = "+375 29 651 48 79";